import { render, staticRenderFns } from "./ContentIntro.vue?vue&type=template&id=24ef5832&lang=pug"
import script from "./ContentIntro.vue?vue&type=script&lang=ts"
export * from "./ContentIntro.vue?vue&type=script&lang=ts"
import style0 from "./ContentIntro.vue?vue&type=style&index=0&id=24ef5832&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports